import * as React from "react";
import styled from "styled-components";

import { SelectorContainer } from "../../../../containers/common/selector";

interface IProps {
  items: string[];
  onClick?(): void;
  onSelect(item: string): void;
  trackChange?(value: string | undefined): void;
  placeholder: string;
  selectedTime?: string;
}

const SearchTimeSelector = styled.div`
  display: inline-block;
  width: 50%;

  input {
    border-radius: 0 20px 20px 0;

    &.active {
      border-radius: 0 20px 0 0;
    }
  }
`;

const SearchTime: React.FC<IProps> = ({
  items,
  onClick,
  onSelect,
  trackChange,
  placeholder,
  selectedTime,
}) => {
  return (
    <SearchTimeSelector>
      <SelectorContainer
        defaultScrollText="6:00 AM"
        items={items}
        placeholder={placeholder}
        selectedItem={selectedTime}
        onClick={onClick}
        onSelect={onSelect}
        {...(trackChange && { trackChange })}
      />
    </SearchTimeSelector>
  );
};

export { SearchTime };
